export default Object.freeze({
    FRESH : 'fresh',
    TRIALING : 'trialing',
    TRIAL_EXPIRED : 'trial_expired',
    ACTIVE : 'active',
    EXPIRED  : 'expired',
})
